import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";
import styles from '../../components/BuildersRisk/BuildersRisk.module.scss';
import presentationMetadata from './PropertyCoveragesPage.metadata.json5';
import messages from './PropertyCoveragesPage.messages';
import CoveragesPageComponent from "../Coverages/CoveragesPage";

function PropertyCoveragesPage(props) {
    const {
        wizardData, updateWizardData, currentStep, callbackMap
    } = props;
    const { pageKey } = currentStep;
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('PropertyCoveragesPage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;

    const onNext = useCallback(
        async () => {

            const {productCode} = wizardData.value.baseData;
            const lobLineName = lineName[productCode];

            wizardData.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', wizardData);

            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(wizardData)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.consTraAndServLine.coverables.locRisks.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';

            await updateSubmission(lobLineName, 'PropertyPage', subVMCopy);
                            
            return wizardData;
        },
        [lineName, wizardData, updateSubmission]
    );
    
    const getAccordianTitle = useCallback((index) => (
        <div className={styles.accordianTitle}>
          <p>
            {_.get(
              wizardData,
              `lobData.consTraAndServLine.coverables.locRisks.children[${index}].accountLocFie.displayName.value`
            )}
          </p>
          {/* <p>
            {`${translator(messages.totalInsValue)}${_.get(
              wizardData,
              `lobData.consTraAndServLine.coverables.locRisks.children[${index}].totInsValFie.value`
            )}`}
          </p> */}
        </div>
      ),[wizardData]);

    const propertyCoveragesOverrides = useMemo(() => {
        const informationList = _.get(wizardData, 'lobData.consTraAndServLine.coverables.locRisks', []);
        let overrides = [];

        if (!_.isEmpty(informationList)) {
            overrides = informationList?.children.map((information, index) => ({
                [`locRiskCoverageComponent${index}`]: {
                    wizardData,
                    updateWizardData,
                    clausesBasePath: `lobData.consTraAndServLine.lineCoverages.locRiskCoverages.pctcoverages.children[${index}].coverages`,
                    title: messages.cov,
                    clasueType: 'coverages',
                    pathToGet: `consTraAndServLine.locRiskCoverages.pctcoverages[${index}].coverages`
                },
                [`additionalInterest${index}`]:{
                    wizardData,
                    updateWizardData,
                    addlIntPath: `lobData.consTraAndServLine.coverables.locRisks.children[${index}].additionalInterests`,
                    isLiaCov: false
                },
                [`propertyCoveragesAccordionDetails${index}`]: {                     
                    title: getAccordianTitle(index),
                    className: styles.gwOuterLocationAccordion
                },
                [`propertyCoveragesAccordion${index}`]: {
                    className: styles.gwAccordionSet
                }
            }));
        }

        return Object.assign({}, ...overrides);
    }, [getAccordianTitle, updateWizardData, wizardData]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        optionalCoverageComponent: {
            wizardData,
            updateWizardData,
            clausesBasePath: `lobData.consTraAndServLine.lineCoverages.propertyCoverages`,
            title: messages.cov,
            clasueType: 'coverages',
            pathToGet: `consTraAndServLine.propertyCoverages`
        },
        ...propertyCoveragesOverrides,

    };

    const resolveCallbackMap = {
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, wizardData, id, path, overrideProps),
        [metadata.content, wizardData, overrideProps]
    );

    const resolveComponentMap = {
        coveragespagecomponent: CoveragesPageComponent,
        AddlInterestTextBoxComponent
    };

    const isDisableNext = () => {
        let result = false
        
        _.each(wizardData.value.lobData.consTraAndServLine.lineCoverages.locRiskCoverages.pctcoverages, (locRiskCov) => {
            if (!result && !_.isUndefined(_.find(locRiskCov.coverages, { isValid: false }))) {
                result = true
            }
        });

        return result
    };

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={!_.get(wizardData, 'lobData.consTraAndServLine.coverables.locRisks').aspects.subtreeValid}
            onNext={onNext}
            onSave={onSave}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={wizardData}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                componentMap={resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PropertyCoveragesPage.propTypes = wizardProps;
export default withViewModelService(PropertyCoveragesPage);
